import { render } from "./Online.vue?vue&type=template&id=45ef5d6c&scoped=true"
import script from "./Online.vue?vue&type=script&lang=js"
export * from "./Online.vue?vue&type=script&lang=js"

import "./Online.vue?vue&type=style&index=0&id=45ef5d6c&lang=scss&scoped=true"
import "./Online.vue?vue&type=style&index=1&id=45ef5d6c&lang=scss"

import exportComponent from "/Users/apple/Documents/xxiwant/lovestory/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ef5d6c"]])

export default __exports__